<template>
  <v-icon class="mr-2" :size="size">{{fileIcon}}</v-icon>
</template>

<script>
export default {
  name: 'FileIcon',
  props: {
    document: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: '18px'
    }
  },
  data() {
    return {
      fileType: '',
      fileTypes: {
        'xlsx': 'fileExcelIcon',
        'xls': 'fileExcelIcon',
        'csv': 'fileExcelIcon',
        'jpg': 'fileJpgIcon',
        'jpeg': 'fileJpgIcon',
        'png': 'fileJpgIcon',
        'tif': 'fileJpgIcon',
        'tiff': 'fileJpgIcon',
        'pdf': 'filePdfIcon',
        'doc': 'fileWordIcon',
        'docx': 'fileWordIcon',
        'zip': 'fileZipIcon',
        'rar': 'fileZipIcon',
        '7z': 'fileZipIcon',
        'tar': 'fileZipIcon',
        'gz': 'fileZipIcon',
        'txt': 'fileTxtIcon',
        'rtf': 'fileRtfIcon',
        'mp3': 'fileMp3Icon',
        'mp4': 'fileMp4Icon',
      }
    };
  },
  computed: {
    fileIcon() {
      const defaultIcon = 'mdi-file-outline';

      if (!this.document || !this.document.fileName) {
        return defaultIcon;
      }

      const fileName = this.document.fileName.toLowerCase();

      for (const [key, value] of Object.entries(this.fileTypes)) {
        if (fileName.endsWith(`.${key}`)) {
          return 'custom:' + value;
        }
      }

      return defaultIcon;
    }
  }
}
</script>

<style scoped>

</style>